// ZM - Reviewed by Claude Portal-Review Deep Dive 2026-05-07
import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { IView, Flexbox, LoadingProgress } from '@framework-controls/core';
import { JSXSwitch, JSXCase } from '@framework-controls/jsxconditions';
import css from './ServiceTab.module.scss';
import MaintenanceMenus from '../MaintenanceMenus/containers/MaintenanceMenus';
import WriteYourOwn from '../WriteYourOwn/containers/WriteYourOwn';
import IndividualServices from '../IndividualServices/containers/IndividualServices';
// import ErrorMessage from 'src/components/ErrorMessage/ErrorMessage';
import SkipLightBox from '../AddSkipServices/SkipLightBox/SkipLightBox';
import { Diagnoses } from '../WriteYourOwn/WriteYourOwn';
import { SpecData, UpdateApptOpsInp, UpdateApptDateInp, ApptCust, OpType, WebOp, WebOpChecked, ApptOps, DeteremineDeptInp, DepartmentSpec, invalidDates, VehicleRecs, Advisor } from 'src/models';
import { ComponentMapIds } from '../map';
import Footer from '../Footer/Footer';
import { IMenusState, IServicesState, IAppointmentState } from 'src/store/states';
import ServiceTabBtn from '../ServiceTab/ServiceTabBtn/ServiceTabBtn';
import { strings } from 'src/localization';
import { ViewMode, ServiceTabButtonIds, DEPT } from 'src/enums';
import { MASKED_COST, NULL_DATE, NO_VEHICLE_SELECTED } from 'src/constants/Sentinels';
import { OP_CODE, OP_ID_PREFIX } from 'src/constants/OpCodes';
import { THEME } from 'src/constants/ThemeNames';
import { BlankDeptSpec } from 'src/models/Specs/TestSpecs';
import { ascCtaInteraction, ascElementConfiguration, ascPageview, ascRetailProcess, getElementColor,
    buildCtaInteractionInput, buildElementConfigurationInput, buildPageviewInput,
    buildRetailProcessInput } from 'src/helpers/EventHelper/EventHelper';
import classNames from 'classnames';
import { sendSdEvent, getProviderId, buildApptData, buildVehicleEventPayload } from 'src/helpers/ShiftDigitalHelper/ShiftDigitalHelper';
import { EventOrElement } from 'src/types';
import { ELEMENT_SUBTYPE, EVENT_ACTION_RESULT, FLOW_STAGE, FLOW_OUTCOME, ELEMENT_TITLE, SD_EVENT } from 'src/constants/Analytics';

export interface IProps {
    appointment: IAppointmentState;
    specData?: SpecData;
    apptCust?: ApptCust;
    specProfile: string;
    webOps: WebOp[];
    webOpChecked: WebOpChecked[];
    maintMenus: IMenusState;
    apptOps: ApptOps[];
    additionalServices: IServicesState;
    specDefaultDept: string;
    specDeptData: DepartmentSpec;
    invalidDates: invalidDates[];
    invalidDatesDept: string;
    apptDept: string;
    theme: string;
    viewMode: ViewMode;
    selectedVehicle?: string;
    vehicles: VehicleRecs;
    apptAdvNum?: string;
    mainPaneViewOrder: IView[];
    locale: string;
    sessionId: string;
    lexusMCLaunched: string;
    toyotaMCLaunched: string;
    lexusTDMCLaunched: string;
    toyotaTDMCLaunched: string;
    colorSensitiveEnabled?: boolean;
    pushToMainPanes: (inputView: IView) => void;
    UpdateApptOps: (inputOps: UpdateApptOpsInp[]) => void;
    getRMTimes: (specProfile: string) => void;
    getInvalidDates: (pecProfile: string) => void;
    determineDept: (inp: DeteremineDeptInp) => void;
    getDeptSpecs: () => void;
    clearInvalidDates: () => void;
    toggleOpsLangLits: (language: string) => void;
    updateApptDate: (inp: UpdateApptDateInp) => void;
}

/** Service selection step of the appointment-add flow. Hosts three sub-tabs
 *  (Maintenance Menu, Individual Services, Write Your Own) for the customer to
 *  choose what kind of service to add. Also handles the skip-services flow
 *  when the customer doesn't want to add any. */
const ServiceTab = (props: IProps) => {
    const btnMaintMenuLit = props.specData?.maintSchTabMsg ? props.specData?.maintSchTabMsg : '';
    const btnIndSvcsLit = props.specData?.indSVCsTabMsg ? props.specData?.indSVCsTabMsg : '';
    const btnWriteYourOwnLit = props.specData?.writeYourOwnTabMsg ? props.specData?.writeYourOwnTabMsg : '';
    const [btnSelected, setBtnSelected] = useState<ServiceTabButtonIds | undefined>();
    const [skipLit, setSkipLit] = useState<boolean>(props.apptOps.length > 0);
    const [disableFooter, setDisableFooter] = useState<boolean>(false);
    const [exitFlag, setExitFlag] = useState<boolean>(false);
    const [boxOpenFlag, setBoxOpenFlag] = useState(false);
    const [moveFlag, setMoveFlag] = useState('');
    const [tabArray, setTabArray] = useState<ServiceTabButtonIds[]>([]);
    const [prevDept, setPrevDept] = useState<string>(props.apptDept);
    const [editApptProceed, setEditApptProceed] = useState<boolean>(false);
    const [unenteredIssue, setUnenteredIssue] = useState<string>('');
    const [unenteredWarning, setUnenteredWarning] = useState<boolean>(false);
    const [unenteredDiagnosis, setUnenteredDiagnosis] = useState<boolean>(false);
    const [maintLength, setMaintLength] = useState(props.maintMenus.allMenus.menus.length);

    const isSDAnalyticsEnabled =
        props.specData?.toyotaTrackingFlag === 'Y' ||
        props.specData?.lexusTrackingFlag === 'Y' ||
        props.specData?.mbzTrackingFlag === 'Y' ||
        props.specData?.mazdaCATrackingFlag === 'Y' ||
        props.specData?.vwTrackingFlag === 'Y' ||
        props.specData?.jaguarTrackingFlag === 'Y' ||
        props.specData?.landRoverTrackingFlag === 'Y';

    const isVW = props.specData?.vwTrackingFlag === 'Y';
    useEffect(() => {
        if (props.specDeptData === BlankDeptSpec) {
            props.getDeptSpecs();
        }
        props.toggleOpsLangLits(props.locale);
    }, [props.specDeptData, props.getDeptSpecs, props.toggleOpsLangLits, props.locale]);

    // opens the skip services warning message
    const skipOpenHandler = useCallback(() => {
        setBoxOpenFlag(true);
    }, []);

    // closes the skip services warning message
    const skipCloseHandler = useCallback((e: any) => {
        setBoxOpenFlag(false);
        ascCtaInteraction(buildCtaInteractionInput({
            elementText: strings.Cancel,
            elementSubType: ELEMENT_SUBTYPE.NAV_BUTTON,
            eventActionResult: EVENT_ACTION_RESULT.CLOSE,
        }), e, props.vehicles, props.selectedVehicle);
    }, [props.vehicles, props.selectedVehicle]);

    const recomTimes = useMemo (() => (
        {
            [DEPT.Service]: props.specData?.svcSpecs?.recommTimes,
            [DEPT.Body]: props.specData?.bdySpecs?.recommTimes,
            [DEPT.OSS]: props.specData?.ossSpecs?.recommTimes,
        }
    ), [props.specData?.svcSpecs?.recommTimes,
        props.specData?.bdySpecs?.recommTimes,
        props.specData?.ossSpecs?.recommTimes]);

    const moveToNextTab = useCallback(() => {
        const current = tabArray.findIndex((element) => element === btnSelected);
        setBtnSelected(tabArray[current+1]);
    }, [tabArray, btnSelected]);

    const skipHandler = useCallback((e: any) => {
        if (unenteredIssue || unenteredDiagnosis) {
            setUnenteredWarning(true);
        }
        if (props.apptOps.length === 0) {
            if (props.specData?.skipServicesFlag) {
                if (btnSelected !== tabArray[tabArray.length-1]) {
                    setUnenteredWarning(false);
                    moveToNextTab();
                } else {
                    if (!(unenteredIssue || unenteredDiagnosis)) {
                        skipOpenHandler();
                    }
                }
            } else {
                if (btnSelected !== tabArray[tabArray.length-1]) {
                    moveToNextTab();
                }
            }
        }
        ascCtaInteraction(buildCtaInteractionInput({
            elementText: skipLit ? strings.Skip : strings.Proceed,
            elementSubType: ELEMENT_SUBTYPE.NAV_BUTTON,
            eventActionResult: EVENT_ACTION_RESULT.NEXT_STEP,
        }), e, props.vehicles, props.selectedVehicle);
        ascElementConfiguration(buildElementConfigurationInput({
            elementText: skipLit ? strings.Skip : strings.Proceed,
            eventActionResult: EVENT_ACTION_RESULT.CLOSE,
        }), e);
    }, [unenteredIssue, unenteredDiagnosis, props.apptOps.length, props.specData?.skipServicesFlag,
        btnSelected, tabArray, moveToNextTab, skipOpenHandler, skipLit, props.vehicles, props.selectedVehicle]);

    useEffect(() => {
        if (!props.specData?.skipServicesFlag) {
            if (btnSelected === tabArray[tabArray.length-1]) {
                setSkipLit(false);
                if (props.additionalServices.checkedWeOwes.length === 0 && props.additionalServices.checkedRecalls.length === 0 &&
                    props.additionalServices.checkedRecoms.length === 0 && props.maintMenus.checkedMileageMenu.length === 0 &&
                    props.maintMenus.checkedConditionalMenus.length === 0 && props.webOpChecked.length === 0 &&
                    props.apptOps.findIndex(op => op.opType === OpType.WriteYourOwn) === -1 &&
                    props.apptOps.findIndex(op => op.opType === OpType.Diagnosis) === -1 &&
                    (props.apptOps.findIndex(op => op.opType === OpType.ViewApptListService) === -1)) {
                    setDisableFooter(true);
                } else {
                    setDisableFooter(false);
                }
            } else {
                setDisableFooter(false);
                if (props.additionalServices.checkedWeOwes.length === 0 && props.additionalServices.checkedRecalls.length === 0 &&
                    props.additionalServices.checkedRecoms.length === 0 && props.maintMenus.checkedMileageMenu.length === 0 &&
                    props.maintMenus.checkedConditionalMenus.length === 0 && props.webOpChecked.length === 0 &&
                    props.apptOps.findIndex(op => op.opType === OpType.WriteYourOwn) === -1 &&
                    props.apptOps.findIndex(op => op.opType === OpType.Diagnosis) === -1 &&
                    (props.apptOps.findIndex(op => op.opType === OpType.ViewApptListService) === -1)) {
                    setSkipLit(true);
                } else {
                    setSkipLit(false);
                }
            }
        } else {
            if (props.additionalServices.checkedWeOwes.length === 0 && props.additionalServices.checkedRecalls.length === 0 &&
            props.additionalServices.checkedRecoms.length === 0 && props.maintMenus.checkedMileageMenu.length === 0 &&
            props.maintMenus.checkedConditionalMenus.length === 0 && props.webOpChecked.length === 0 &&
            props.apptOps.findIndex(op => op.opType === OpType.WriteYourOwn) === -1 &&
            props.apptOps.findIndex(op => op.opType === OpType.Diagnosis) === -1 &&
            (props.apptOps.findIndex(op => op.opType === OpType.ViewApptListService) === -1)) {
                setSkipLit(true);
            } else {
                setSkipLit(false);
                setDisableFooter(false);
            }
        }
    }, [props.specData?.skipServicesFlag,
        btnSelected,
        tabArray,
        props.additionalServices,
        props.maintMenus,
        props.webOpChecked,
        props.apptOps]);

    /** Handles the 'skip services' flow — when the user chooses to proceed without
     *  adding any services. Adds a SkipServiceReason op with the provided reason,
     *  re-resolves the department spec, validates the previous advisor against the
     *  new dept's advisor list, and routes to the next view. */
    const skipProceed = (reason: string) => {
        // if (props.specData?.recommendedTimes && props.apptCust?.custFirstName !== '') {
        if (skipLit) {
            let apptOpsCopy: UpdateApptOpsInp[] = [...props.apptOps];
            // If the skipServiceReason already exists, delete it first
            const skipServiceIndex = apptOpsCopy.findIndex(op => op.opType === OpType.SkipServiceReason);
            if (skipServiceIndex !== -1) {
                apptOpsCopy.splice(skipServiceIndex, 1);
            }
            apptOpsCopy = [
                ...apptOpsCopy,
                {
                    id: OP_ID_PREFIX.SKIP_REASON,
                    operation: OP_CODE.SKIP_REASON,
                    concern: reason,
                    estTime: '',
                    menuID: '',
                    spgOp: '',
                    opType: OpType.SkipServiceReason,
                    // department: 'S',
                    department: props.specDefaultDept,
                    itemCostLow: MASKED_COST,
                    itemCostHigh: MASKED_COST,
                    opWaiter: '',
                    opLoaner: '',
                    opRental: '',
                    opConcierge: '',
                    opCadillac: '',
                    opPPUDWL: '',
                },
            ];
            props.UpdateApptOps(apptOpsCopy);
            const defaultDept = props.specDefaultDept;
            const determineDept = {
                defaultDept: defaultDept,
            };
            props.determineDept(determineDept);
            props.getDeptSpecs();
            setExitFlag(false);
            // const quickType = props.specDeptData.recTimesCtgry;
            // let advName = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastAdvName : '';
            let advNumber = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastAdv : '';
            if (advNumber) {
                const advIndex = props.specDeptData.Advisors.findIndex(adv => adv.advisorNum === advNumber);
                if (advIndex === -1) {
                    // advName = '';
                    advNumber = '';
                }
            }
            let transLit = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastTransLit : '';
            const transType = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastTrans : '';
            if (transLit) {
                const transIndex = props.specDeptData.Transportation.findIndex(trans => trans.type === transType);
                if (transIndex === -1) {
                    transLit = '';
                }
            }
            // if (props.specData?.recommendedTimes && props.apptCust?.custFirstName !== '') {
            // if the department has changed and the current advisor is no longer valid we need to go to calandar select
            if (props.viewMode === ViewMode.EditAppt) {
                setEditApptProceed(true);
            } else {
                let skipQuickTimes = true;
                if (recomTimes[props.apptDept] === 'Y' && props.apptCust?.custFirstName !== '' &&
                    props.apptCust?.custNameId !== '') {
                    // if ((quickType === 'A' && advName !== '') || (quickType === 'T' && transLit !== '')) {
                    skipQuickTimes = false;
                    // }
                }
                if (skipQuickTimes) {
                    // Refetch invalid dates when the dept changed OR when they were cleared (e.g.
                    // removing then re-adding a job in the same dept clears them). GetInvalidDates
                    // always returns the '00/00/00' built marker as element 0, which the moveFlag
                    // effect watches for to navigate to CalendarSelect, so no direct push is needed.
                    if (props.apptDept !== props.invalidDatesDept || props.invalidDates.length === 0) {
                        props.clearInvalidDates();
                        props.getInvalidDates(props.specProfile);
                    }
                    setMoveFlag('T');
                } else {
                    props.pushToMainPanes({
                        viewId: ComponentMapIds.QuickTime,
                        component: ComponentMapIds.QuickTime,
                    });
                }
                ascRetailProcess(buildRetailProcessInput({
                    flowStage: FLOW_STAGE.SKIP_SERVICES,
                    flowOutcome: FLOW_OUTCOME.PROCEED,
                    elementTitle: ELEMENT_TITLE.SKIP_SERVICES,
                }), props.vehicles, props.selectedVehicle);
            }
            if (isSDAnalyticsEnabled) {
                sendSdEvent(SD_EVENT.SELECTION_FINISH, buildApptData(props.sessionId,
                    getProviderId(props.specData, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                        props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
            }
        }
        setBoxOpenFlag(false);
    };

    useEffect(() => {
        let checkDate = '';
        if (props.invalidDates[0]) {
            checkDate = props.invalidDates[0].date;
        }
        if (moveFlag === 'T' && (checkDate === NULL_DATE)) {
            setMoveFlag('');
            props.pushToMainPanes({
                viewId: ComponentMapIds.CalendarSelect,
                component: ComponentMapIds.CalendarSelect,
            });
        }
    }, [moveFlag, props.pushToMainPanes, props.invalidDates]);

    // Determine how many tabs we display to keep track for the skip/proceed button
    useEffect(() => {
        const setter: ServiceTabButtonIds[] = [];
        if (props.maintMenus.allMenus.menus && props.maintMenus.allMenus?.menus[0]) {
            setter.push(ServiceTabButtonIds.MaintMenu);
        }
        if (props.webOps?.[0]) {
            setter.push(ServiceTabButtonIds.IndSvcs);
        }
        if (props.specData?.showDiagnTool || props.specData?.showWrtYourOwn) {
            setter.push(ServiceTabButtonIds.WriteYour);
        }
        setTabArray(setter);
    }, [props.maintMenus,
        props.webOps,
        props.specData?.showDiagnTool,
        props.specData?.showWrtYourOwn]);

    useEffect(() => {
        if (exitFlag && !skipLit) {
            setExitFlag(false);
            // const quickType = props.specDeptData.recTimesCtgry;
            // let advName = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastAdvName : '';
            let advNumber = props.selectedVehicle && props.selectedVehicle !== NO_VEHICLE_SELECTED ?
                props.vehicles[props.selectedVehicle].lastAdv : '';
            if (advNumber) {
                const advIndex = props.specDeptData.Advisors.findIndex(adv => adv.advisorNum === advNumber);
                if (advIndex === -1) {
                    // advName = '';
                    advNumber = '';
                }
            }
            let transLit = props.selectedVehicle && props.selectedVehicle !== NO_VEHICLE_SELECTED ?
                props.vehicles[props.selectedVehicle].lastTransLit : '';
            const transType = props.selectedVehicle && props.selectedVehicle !== NO_VEHICLE_SELECTED ?
                props.vehicles[props.selectedVehicle].lastTrans : '';
            if (transLit) {
                const transIndex = props.specDeptData.Transportation.findIndex(trans => trans.type === transType);
                if (transIndex === -1) {
                    transLit = '';
                }
            }
            // if (props.specData?.recommendedTimes && props.apptCust?.custFirstName !== '') {
            // if the department has changed and the current advisor is no longer valid we need to go to calandar select
            if (props.viewMode === ViewMode.EditAppt) {
                setEditApptProceed(true);
            } else {
                // If recoommend Times is active in specs and we have a valid customer then we want to go to
                // the QuickSelect screen.  But we only want to go there if we have a lastAdv or lastTrans for
                // vehicle.  This is based on if specs indicates if recommended times is based on Adv or Trans
                let skipQuickTimes = true;
                if (recomTimes[props.apptDept] === 'Y' && props.apptCust?.custFirstName !== '' &&
                    props.apptCust?.custNameId !== '') {
                    // if ((quickType === 'A' && advName !== '') || (quickType === 'T' && transLit !== '')) {
                    skipQuickTimes = false;
                    // }
                }
                if (skipQuickTimes) {
                    // Refetch invalid dates when the dept changed OR when they were cleared (e.g.
                    // removing then re-adding a job in the same dept clears them). GetInvalidDates
                    // always returns the '00/00/00' built marker as element 0, which the moveFlag
                    // effect watches for to navigate to CalendarSelect, so no direct push is needed.
                    if (props.apptDept !== props.invalidDatesDept || props.invalidDates.length === 0) {
                        props.clearInvalidDates();
                        props.getInvalidDates(props.specProfile);
                    }
                    setMoveFlag('T');
                } else {
                    props.pushToMainPanes({
                        viewId: ComponentMapIds.QuickTime,
                        component: ComponentMapIds.QuickTime,
                    });
                }
                ascRetailProcess(buildRetailProcessInput({
                    flowStage: FLOW_STAGE.ADD_SERVICES,
                    flowOutcome: FLOW_OUTCOME.ADDED,
                    elementTitle: ELEMENT_TITLE.ADD_SERVICES,
                }), props.vehicles, props.selectedVehicle);
            }
            if (isSDAnalyticsEnabled) {
                sendSdEvent(SD_EVENT.SELECTION_FINISH, buildApptData(props.sessionId,
                    getProviderId(props.specData, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                        props.lexusMCLaunched, props.lexusTDMCLaunched), props.appointment));
            }
        }
    }, [props.apptDept, props.invalidDatesDept, props.invalidDates, props.clearInvalidDates, props.getInvalidDates,
        props.specProfile, props.apptCust, props.pushToMainPanes, props.selectedVehicle, props.specDeptData,
        props.vehicles, props.viewMode, exitFlag, setExitFlag, skipLit, recomTimes, props.sessionId,
        props.specData, props.toyotaMCLaunched, props.toyotaTDMCLaunched, props.lexusMCLaunched, props.lexusTDMCLaunched,
        isSDAnalyticsEnabled, props.appointment]);

    // the point of this logic is to select the starting tab based on the data available
    // we do not want it to trigger on every render so we use the useEffect hook
    // and check if it is already set since the language toggle can change webOps
    useEffect(() => {
        if (btnSelected === undefined) {
            if (props.maintMenus.allMenus.menus && props.maintMenus.allMenus.menus[0]) {
                setBtnSelected(ServiceTabButtonIds.MaintMenu);
            } else {
                if (props.webOps?.[0]) {
                    setBtnSelected(ServiceTabButtonIds.IndSvcs);
                } else {
                    setBtnSelected(ServiceTabButtonIds.WriteYour);
                }
            }
        }
    }, [props.maintMenus.allMenus.menus, props.webOps, setBtnSelected, btnSelected]);

    const addWriteYourOwn = useCallback((diagnosis: Diagnoses) => {
        let writeYourOwnCount = 0;
        props.apptOps.forEach((apptOp) => {
            if (apptOp.opType === OpType.WriteYourOwn || apptOp.opType === OpType.Diagnosis) {
                writeYourOwnCount++;
            }
        });
        const apptOpsCopy: UpdateApptOpsInp[] = [
            ...props.apptOps,
            {
                id: OP_ID_PREFIX.DIAGNOSIS + writeYourOwnCount,
                operation: diagnosis.opType === OpType.Diagnosis ? OP_CODE.DIAGNOSIS : OP_CODE.WRITE_YOUR_OWN,
                concern: diagnosis.comment ? `${diagnosis.diagnosis} ${diagnosis.comment}` : diagnosis.diagnosis,
                estTime: '',
                menuID: '',
                spgOp: '',
                opType: diagnosis.opType,
                department: props.specDefaultDept,
                itemCostLow: MASKED_COST,
                itemCostHigh: MASKED_COST,
                opWaiter: '',
                opLoaner: '',
                opRental: '',
                opConcierge: '',
                opCadillac: '',
                opPPUDWL: '',
            },
        ];
        props.UpdateApptOps(apptOpsCopy);
        const defaultDept = props.specDefaultDept;
        const determineDept = {
            defaultDept: defaultDept,
        };
        props.determineDept(determineDept);
        props.getDeptSpecs();
    }, [props.UpdateApptOps, props.apptOps, props.determineDept, props.specDefaultDept, props.getDeptSpecs]);

    /** Removes a previously-added Write Your Own op (by id) from the appointment's
     *  ops list. Also fires the 'x' CTA analytics event. */
    const removeWriteYourOwn = (id: string, e: EventOrElement) => {
        // Filter out the removed id
        let apptOpsCopy = props.apptOps.filter((apptOp) => apptOp.id !== id);
        let writeYourOwnCount = 0;
        const elementColor = getElementColor(e, 'color');
        ascCtaInteraction(buildCtaInteractionInput({
            elementText: 'x',
            elementColor: elementColor,
            elementSubType: ELEMENT_SUBTYPE.OTHER_BUTTONS,
            eventActionResult: EVENT_ACTION_RESULT.CLOSE,
        }), e, props.vehicles, props.selectedVehicle);
        ascElementConfiguration(buildElementConfigurationInput({
            elementText: 'x',
            elementColor: elementColor,
            eventActionResult: EVENT_ACTION_RESULT.CLOSE,
        }), e);
        apptOpsCopy = apptOpsCopy.map((apptOp) => {
            let newId = apptOp.id;
            // Rewrite the writeYourOwn ids
            if (apptOp.opType === OpType.WriteYourOwn || apptOp.opType === OpType.Diagnosis) {
                newId = OP_ID_PREFIX.DIAGNOSIS + writeYourOwnCount;
                writeYourOwnCount++;
            }
            // Use the spread operator so we aren't modifying the original

            return {...apptOp, id: newId};
        });

        props.UpdateApptOps(apptOpsCopy);
        const defaultDept = props.specDefaultDept;
        const determineDept = {
            defaultDept: defaultDept,
        };
        props.determineDept(determineDept);
        props.getDeptSpecs();
    };

    const filteredWriteYourOwn = props.apptOps.filter((apptOp) => (
        apptOp.opType === OpType.WriteYourOwn || apptOp.opType === OpType.Diagnosis));
    const diagnoses: Diagnoses[] = [];
    filteredWriteYourOwn.forEach((writeYourOwn) => {
        diagnoses.push({
            id: writeYourOwn.id,
            comment: writeYourOwn.operation,
            diagnosis: writeYourOwn.concern,
            opType: writeYourOwn.opType,
        });
    });

    useEffect(() => {
        if (editApptProceed) {
            setEditApptProceed(false);
            // check if prevDept is equal to current dept
            if (prevDept === props.apptDept) {
                props.pushToMainPanes({
                    viewId: ComponentMapIds.CalendarSelect,
                    component: ComponentMapIds.CalendarSelect,
                });
            } else {
                // obtain varaiables needed for quicktime logic
                // const quickType = props.specDeptData.recTimesCtgry;
                // let advName = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastAdvName : '';
                let advNumber = props.selectedVehicle && props.selectedVehicle !== NO_VEHICLE_SELECTED ?
                    props.vehicles[props.selectedVehicle].lastAdv : '';
                if (advNumber) {
                    const advIndex = props.specDeptData.Advisors.findIndex(adv => adv.advisorNum === advNumber);
                    if (advIndex === -1) {
                        // advName = '';
                        advNumber = '';
                    }
                }
                let transLit = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastTransLit : '';
                const transType = props.selectedVehicle ? props.vehicles[props.selectedVehicle].lastTrans : '';
                if (transLit) {
                    const transIndex = props.specDeptData.Transportation.findIndex(trans => trans.type === transType);
                    if (transIndex === -1) {
                        transLit = '';
                    }
                }
                // find the advisor in the deptSpecs advisor list
                let advFound = false;
                let apptDeptAdvisors: Advisor[] = [];
                switch (props.apptDept) {
                    case DEPT.Body:
                        apptDeptAdvisors = props.specData!.bdySpecs!.Advisors;
                        break;
                    case DEPT.PDI:
                        apptDeptAdvisors = props.specData!.pdiSpecs!.Advisors;
                        break;
                    case DEPT.OSS:
                        apptDeptAdvisors = props.specData!.ossSpecs!.Advisors;
                        break;
                    default:
                        apptDeptAdvisors = props.specData!.svcSpecs!.Advisors;
                        break;
                }
                apptDeptAdvisors.forEach((advisor) => {
                    if (advisor.advisorNum === props.apptAdvNum) {
                        advFound = true;
                    }
                });
                if (advFound) {
                    props.pushToMainPanes({
                        viewId: ComponentMapIds.Summary,
                        component: ComponentMapIds.Summary,
                    });
                } else {
                    let skipQuickTimes = true;
                    if (recomTimes[props.apptDept] === 'Y' && props.apptCust?.custFirstName !== '' &&
                        props.apptCust?.custNameId !== '') {
                        // if ((quickType === 'A' && advName !== '') || (quickType === 'T' && transLit !== '')) {
                        skipQuickTimes = false;
                        // }
                    }
                    if (skipQuickTimes) {
                        // Refetch invalid dates when the dept changed OR when they were cleared (e.g.
                        // removing then re-adding a job in the same dept clears them). GetInvalidDates
                        // always returns the '00/00/00' built marker as element 0, which the moveFlag
                        // effect watches for to navigate to CalendarSelect, so no direct push is needed.
                        if (props.apptDept !== props.invalidDatesDept || props.invalidDates.length === 0) {
                            props.clearInvalidDates();
                            props.getInvalidDates(props.specProfile);
                        }
                        setMoveFlag('T');
                    } else {
                        props.pushToMainPanes({
                            viewId: ComponentMapIds.QuickTime,
                            component: ComponentMapIds.QuickTime,
                        });
                    }
                }
            }
            setPrevDept(props.apptDept);
        }
    }, [props.apptDept,
        props.pushToMainPanes,
        props.apptAdvNum,
        props.clearInvalidDates,
        props.getInvalidDates,
        props.invalidDatesDept,
        props.invalidDates,
        props.specProfile,
        props.apptCust,
        props.selectedVehicle,
        props.specDeptData,
        props.vehicles,
        props.specData,
        prevDept,
        editApptProceed,
        recomTimes]);

    const warningProceed = useCallback(() => {
        if (btnSelected !== tabArray[tabArray.length-1]) {
            moveToNextTab();
        } else {
            props.getDeptSpecs();
            setExitFlag(true);
        }
    }, [props.getDeptSpecs, btnSelected, tabArray, moveToNextTab]);

    /** Footer Proceed button handler. Clears any prior date/time/advisor selection,
     *  then routes the user to QuickTime if the dept supports recommended-times,
     *  else CalendarSelect. */
    const footerHandler = useCallback((e: any) => {
        const inp: UpdateApptDateInp = {
            selDate: '',
            selTime: '',
            selAdv: '',
            selTrans: '',
            selAdvName: '',
            selAdvImage: '',
            selTransFlag: '',
            selApptNum: props.appointment.Appointment.apptNum ? props.appointment.Appointment.apptNum : '',
        };
        props.updateApptDate(inp);
        const apptOpsCopy: UpdateApptOpsInp[] = [...props.apptOps];
        // If the skipServiceReason exists, delete it
        const skipServiceIndex = apptOpsCopy.findIndex(op => op.opType === OpType.SkipServiceReason);
        if (skipServiceIndex !== -1) {
            apptOpsCopy.splice(skipServiceIndex, 1);
        }
        props.UpdateApptOps(apptOpsCopy);
        if (!unenteredWarning && (unenteredDiagnosis || unenteredIssue) &&
        (btnSelected === tabArray[tabArray.length-1])) {
            setUnenteredWarning(true);
        } else {
            if (btnSelected !== tabArray[tabArray.length-1]) {
                moveToNextTab();
            } else {
                props.getDeptSpecs();
                setExitFlag(true);
            }
        }
        ascCtaInteraction(buildCtaInteractionInput({
            elementText: skipLit ? strings.Skip : strings.Proceed,
            elementSubType: ELEMENT_SUBTYPE.NAV_BUTTON,
            eventActionResult: EVENT_ACTION_RESULT.NEXT_STEP,
        }), e, props.vehicles, props.selectedVehicle);
        ascElementConfiguration(buildElementConfigurationInput({
            elementText: skipLit ? strings.Skip : strings.Proceed,
            eventActionResult: EVENT_ACTION_RESULT.NEXT_STEP,
        }), e);
    }, [
        unenteredIssue, unenteredWarning, unenteredDiagnosis, props.apptOps, skipLit,
        props.UpdateApptOps, props.getDeptSpecs, btnSelected, tabArray, moveToNextTab,
        props.vehicles, props.selectedVehicle, props.appointment, props.updateApptDate,
    ]);

    /** Click handler for the three sub-tab buttons (Maintenance Menu /
     *  Individual Services / Write Your Own). Switches the active tab and
     *  fires a CTA analytics event with the tab's label. */
    const selectSvcTabBtn = (btn: ServiceTabButtonIds, e: any) => {
        setBtnSelected(btn);
        let elementText = '';
        switch (btn) {
            case ServiceTabButtonIds.IndSvcs:
                elementText = btnIndSvcsLit;
                setMaintLength(0);
                break;
            case ServiceTabButtonIds.MaintMenu:
                elementText = btnMaintMenuLit;
                setMaintLength(props.maintMenus.allMenus.menus.length);
                break;
            case ServiceTabButtonIds.WriteYour:
                elementText = btnWriteYourOwnLit;
                setMaintLength(0);
                break;
            default:
                elementText = '';
        }
        ascCtaInteraction(buildCtaInteractionInput({
            elementText: elementText,
            elementSubType: ELEMENT_SUBTYPE.NAV_TAB,
            eventActionResult: EVENT_ACTION_RESULT.NEXT_STEP,
        }), e, props.vehicles, props.selectedVehicle);
    };

    let haveMaintMenu = false;
    if (props.maintMenus.allMenus.menus) {
        if (props.maintMenus.allMenus.menus[0]) {
            haveMaintMenu = true;
        }
    }
    // const haveMaintMenu = props.maintMenus.allMenus?.menus[0] ?? '';
    // const haveWebOps = props.webOps[0] ?? '';
    let haveWebOps = false;
    if (props.webOps) {
        if (props.webOps[0]) {
            haveWebOps = true;
        }
    }

    useEffect(() => {
        const currentTab = props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1].viewId;
        if (haveMaintMenu && btnSelected === ServiceTabButtonIds.MaintMenu && currentTab === ComponentMapIds.ServiceTab) {
            ascPageview(buildPageviewInput({
                itemResults: maintLength.toString(),
            }), props.vehicles, props.selectedVehicle);
        }
    }, [haveMaintMenu, maintLength, props.vehicles, props.selectedVehicle, btnSelected, props.mainPaneViewOrder]);

    useEffect(() => {
        const currentPane = props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1].viewId;
        if (currentPane === ComponentMapIds.ServiceTab && isSDAnalyticsEnabled && isVW) {
            sendSdEvent('scheduleServiceSelectionShown', buildVehicleEventPayload(props.sessionId,
                getProviderId(props.specData, props.toyotaMCLaunched, props.toyotaTDMCLaunched,
                    props.lexusMCLaunched, props.lexusTDMCLaunched),
                props.appointment.ApptVeh));
        }
    }, [props.mainPaneViewOrder, isSDAnalyticsEnabled, isVW, props.sessionId, props.specData,
        props.toyotaMCLaunched, props.toyotaTDMCLaunched, props.lexusMCLaunched,
        props.lexusTDMCLaunched, props.appointment]);
    const tabDivClassNames = classNames(
        css.tabDiv,
        {
            [css.tabDivCadillac]: props.theme === 'cadillac',
        },
    );
    const mainDivClassNames = classNames(
        css.mainDiv,
        {
            [css.mainDivAudi]: props.theme === THEME.AUDI,
        },
    );
    const proceedWarnClassNames = classNames(
        css.proceedWarn,
        {
            [css.proceedWarnAudi]: props.theme === THEME.AUDI,
        },
    );

    return (
        <div>
            <SkipLightBox
                cancel={skipCloseHandler}
                proceed={skipProceed}
                dialogOpen={boxOpenFlag}
                specSkipMsg={props.specData?.skipSVCMsg}
                theme={props.theme}
                selectedVehicle={props.selectedVehicle}
                vehicles={props.vehicles}
            />
            {/* The ErrorMessage will appear to confirm the user wants to Skip adding services. */}
            {/* {boxOpenFlag ? <ErrorMessage
                headerMsg=''
                errorMsg={props.specData?.skipSVCMsg ? props.specData?.skipSVCMsg : ''}
                primaryBtnMessage={strings.Continue}
                secondaryBtnMessage={strings.Cancel}
                primaryHandler={skipProceed}
                primaryArrow
                secondaryHandler={skipCloseHandler}
                closeHandler={skipCloseHandler}
            /> : null} */}
            {moveFlag ? <LoadingProgress cssClasses={{ spinner: css.progressColor }} size={100} /> : null}
            <div className={mainDivClassNames}>
                <div className={tabDivClassNames}>
                    <Flexbox
                        container
                        spacing={0}
                        direction={'row'}
                        noMargin={false}
                        alignItems={'center'}
                        justify={'space-around'}
                    >
                        {/* {props.maintMenus.allMenus?.menus[0] ? */}
                        { haveMaintMenu ?
                            <ServiceTabBtn
                                id={ServiceTabButtonIds.MaintMenu}
                                label={btnMaintMenuLit}
                                onClick={(e: any) => selectSvcTabBtn(ServiceTabButtonIds.MaintMenu, e)}
                                selected={btnSelected === ServiceTabButtonIds.MaintMenu}
                                colorSensitiveEnabled={props.colorSensitiveEnabled}
                                theme={props.theme}
                            /> : null}
                        {/* {props.webOps[0] ? */}
                        { haveWebOps ?
                            <ServiceTabBtn
                                id={ServiceTabButtonIds.IndSvcs}
                                label={btnIndSvcsLit}
                                onClick={(e: any) => selectSvcTabBtn(ServiceTabButtonIds.IndSvcs, e)}
                                selected={btnSelected === ServiceTabButtonIds.IndSvcs}
                                colorSensitiveEnabled={props.colorSensitiveEnabled}
                                theme={props.theme}
                            /> : null}
                        {props.specData?.showDiagnTool || props.specData?.showWrtYourOwn ?
                            <ServiceTabBtn
                                id={ServiceTabButtonIds.WriteYour}
                                label={btnWriteYourOwnLit}
                                onClick={(e: any) => selectSvcTabBtn(ServiceTabButtonIds.WriteYour, e)}
                                selected={btnSelected === ServiceTabButtonIds.WriteYour}
                                colorSensitiveEnabled={props.colorSensitiveEnabled}
                                theme={props.theme}
                            /> : null}
                    </Flexbox>
                </div>
                <div className={css.tabPane}>
                    <JSXSwitch>
                        <JSXCase Condition={btnSelected === ServiceTabButtonIds.MaintMenu}>
                            <MaintenanceMenus />
                        </JSXCase>
                        <JSXCase Condition={btnSelected === ServiceTabButtonIds.IndSvcs}>
                            <IndividualServices tabSwitch={setBtnSelected} />
                        </JSXCase>
                        <JSXCase Condition={btnSelected === ServiceTabButtonIds.WriteYour}>
                            <WriteYourOwn
                                diagnoses={diagnoses}
                                addDiagnosis={addWriteYourOwn}
                                removeDiagnosis={removeWriteYourOwn}
                                unenteredIssue={unenteredIssue}
                                unenteredDiagnosis={unenteredDiagnosis}
                                setUnenteredIssue={setUnenteredIssue}
                                setUnenteredDiagnosis={setUnenteredDiagnosis}
                                unenteredWarning={unenteredWarning}
                                setUnenteredWarning={setUnenteredWarning}
                                warningProceed={warningProceed}
                                boxOpenFlag={boxOpenFlag}
                                setBoxOpenFlag={setBoxOpenFlag}
                            />
                        </JSXCase>
                    </JSXSwitch>
                </div>
            </div>
            {/* Will proceed if the user has services in cart otherwise it will display a warning message
                about skipping. */}
            {disableFooter ? <div className={proceedWarnClassNames}>{strings.PleaseSelectService}</div>:null}
            <Footer
                id='SvcTabFooter'
                handler={skipLit ? skipHandler : footerHandler}
                message={skipLit ? strings.Skip : strings.Proceed}
                isDisabled={disableFooter}
                secondaryhandler={footerHandler}
                theme={props.theme}/>
        </div>
    );
};
export default ServiceTab;